<h2 mat-dialog-title>Add Base Qualification First</h2>
<mat-dialog-content class="mat-typography">
    <p>Select and save at least one base qualification in order to add an exception group.</p>
</mat-dialog-content>
<mat-dialog-actions class="!pt-3 !pb-6" align="end">
    <button mat-flat-button mat-dialog-close color="primary" style="width: 30%">Ok</button>
</mat-dialog-actions>
